import EventBus from '../../utils/EventBus'
import CartEvent from '../utils/CartEvent'
import localforage from 'localforage'

const LF_KEY = 'SC_CART'

class CartService {
  constructor () {
    this.initPromise = new Promise((resolve, reject) => {
      localforage.getItem(LF_KEY).then((cart) => {
        if (cart !== null) {
          this.elements = cart.elements
          this.sumQuantity = cart.sumQuantity
          this.total = cart.total
        } else {
          this.elements = []
          this.sumQuantity = 0
          this.total = 0
        }

        this.emit(CartEvent.INIT)
        resolve()
      }).catch(err => {
        console.log(err)
        reject(err)
      })
    })
  }

  afterInit (fn) {
    this.initPromise.then(() => {
      fn({ elements: this.elements, sumQuantity: this.sumQuantity, total: this.total })
    })
  }

  add (cartProduct) {
    if (this.elements.length > 0) {
      var foundElement = this.findElement(cartProduct.id)
      if (foundElement) {
        foundElement.element.quantity += cartProduct.quantity
        this.sumQuantity += cartProduct.quantity
        this.total += cartProduct.price * cartProduct.quantity
        this.store()
        this.emit(CartEvent.ADD_PRODUCT, cartProduct)
        return
      }
    }

    this.elements.push(cartProduct)
    this.sumQuantity = this.calcSumQuantity()
    this.total = this.calcTotal()

    this.store()
    this.emit(CartEvent.ADD_PRODUCT, cartProduct)
  }

  remove (cartProduct) {
    if (this.elements.length === 0) {
      return
    }

    var elementFound = this.findElement(cartProduct.id)
    if (!elementFound) {
      return
    }
    if (elementFound.element.quantity > cartProduct.quantity) {
      elementFound.element.quantity -= cartProduct.quantity
    } else {
      this.elements.splice(elementFound.index, 1)
    }

    this.sumQuantity = this.calcSumQuantity()
    this.total = this.calcTotal()
    this.store()
    this.emit(CartEvent.REMOVE_PRODUCT, cartProduct)
  }

  updateProduct (product) {
    var el = this.findElement(product.id)
    if (!el) return

    this.elements[el.index] = product

    this.sumQuantity = this.calcSumQuantity()
    this.total = this.calcTotal()

    this.store()
    this.emit(CartEvent.UPDATE_PRODUCT)
  }

  clear () {
    this.elements = []
    this.sumQuantity = 0
    this.total = 0
    this.store()
    this.emit(CartEvent.CLEAR)
  }

  getElements () {
    return this.elements
  }

  emit (event, data) {
    EventBus.$emit(event, { elements: this.elements, sumQuantity: this.sumQuantity, total: this.total, data: data })
  }

  store () {
    localforage.setItem(LF_KEY, { elements: this.elements, sumQuantity: this.sumQuantity, total: this.total })
  }

  findElement (id) {
    for (var item in this.elements) {
      var el = this.elements[item]
      if (el.id === id) {
        return {
          element: el,
          index: item
        }
      }
    }
  }

  calcSumQuantity () {
    return this.elements.reduce((accumulator, el) => accumulator + el.quantity, 0)
  }

  calcTotal () {
    return this.elements.reduce((accumulator, el) => accumulator + el.price * el.quantity, 0)
  }
}

export default new CartService()
